export interface RegistriaSnippetResponse {
  bullet_points: string[];
  button_text: string;
  header_text: string;
  message: string;
  success: boolean;
  url: string;
}
